import React, { useState } from 'react';
import { ApiService } from '../services/api';

const TestConnection: React.FC = () => {
  const [testResult, setTestResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testBackendConnection = async () => {
    setLoading(true);
    setTestResult('Test en cours...');
    
    try {
      // Test 1: Health Check
      const healthResponse = await ApiService.healthCheck();
      setTestResult(`✅ Health Check: ${healthResponse.message}\n`);
      
      // Test 2: Créer une session
      const sessionResponse = await ApiService.createSession('Test Session', 'teacher_test');
      setTestResult(prev => prev + `✅ Session créée: ${sessionResponse.session.code}\n`);
      
      // Test 3: Rejoindre la session
      const joinResponse = await ApiService.joinSession(
        sessionResponse.session.code, 
        'student_test', 
        'Test Student'
      );
      setTestResult(prev => prev + `✅ Étudiant connecté: ${joinResponse.session.name}\n`);
      
      // Test 4: Créer une question
      const questionResponse = await ApiService.createQuestion({
        sessionId: sessionResponse.session.id,
        type: 'multiple_choice',
        title: 'Test Question',
        content: 'Quelle est la capitale de la France?',
        options: [
          { id: 'a', text: 'Paris' },
          { id: 'b', text: 'Londres' },
          { id: 'c', text: 'Berlin' }
        ],
        correctAnswer: 'a'
      });
      
      setTestResult(prev => prev + `✅ Question créée: ${questionResponse.question.title}\n`);
      setTestResult(prev => prev + `\n🎉 Tous les tests sont passés avec succès !\n`);
      setTestResult(prev => prev + `📊 Résumé:\n`);
      setTestResult(prev => prev + `- Code de session: ${sessionResponse.session.code}\n`);
      setTestResult(prev => prev + `- ID de session: ${sessionResponse.session.id}\n`);
      setTestResult(prev => prev + `- Question ID: ${questionResponse.question.id}\n`);
      
    } catch (error: any) {
      setTestResult(`❌ Erreur: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container">
      <header className="header">
        <div className="header-content">
          <h1 className="logo">Test de Connexion</h1>
        </div>
      </header>

      <main className="main-content">
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">🔗 Test de Connexion Frontend ↔ Backend</h2>
          </div>
          
          <div className="card-content">
            <p className="mb-3">
              Ce test vérifie que le frontend peut communiquer correctement avec le backend.
              Il va tester toutes les principales fonctionnalités de l'API.
            </p>
            
            <button 
              className="btn btn-primary"
              onClick={testBackendConnection}
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="spinner" style={{ width: '20px', height: '20px', borderWidth: '2px' }}></div>
                  Test en cours...
                </>
              ) : (
                '🚀 Lancer les tests'
              )}
            </button>
          </div>
        </div>

        {testResult && (
          <div className="card mt-4">
            <div className="card-header">
              <h3 className="card-title">📋 Résultats des tests</h3>
            </div>
            <div className="card-content">
              <pre style={{ 
                background: '#f8f9fa', 
                padding: '1rem', 
                borderRadius: '4px',
                whiteSpace: 'pre-wrap',
                fontFamily: 'monospace',
                fontSize: '14px'
              }}>
                {testResult}
              </pre>
            </div>
          </div>
        )}

        <div className="card mt-4">
          <div className="card-header">
            <h3 className="card-title">📊 Informations de connexion</h3>
          </div>
          <div className="card-content">
            <div className="grid grid-2">
              <div>
                <strong>Frontend:</strong><br />
                http://localhost:3000
              </div>
              <div>
                <strong>Backend API:</strong><br />
                http://localhost:5001
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TestConnection;
